import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const AreYouReady = () => {
  const whatsappMessage =
    'Hola, me interesa la propuesta de cobertura 360 de TNO Network para Expo Mascotas Caracas con Pedro con las Mascotas y Pedro Scutaro.';

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography variant="h4" fontWeight={700} gutterBottom align="center">
          ¿Listos para que Expo Mascotas Caracas deje huella?
        </Typography>
        <Typography align="center" color="textSecondary" variant="h6" sx={{ maxWidth: 700, mx: 'auto' }}>
          Porque ellos también tienen una historia que contar. En TNO nos
          conectamos para celebrarlos con Pedro con las Mascotas y Pedro Scutaro
          como host oficial.
        </Typography>
      </Box>
      <Box maxWidth={520} margin="0 auto">
        <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} gap={2} justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            size="large"
            fullWidth
            sx={{ height: 54 }}
            onClick={() =>
              window.open(
                `https://wa.me/584123964576?text=${encodeURIComponent(whatsappMessage)}`,
                '_blank'
              )
            }
          >
            Solicitar propuesta Expo Mascotas
          </Button>
          <Button
            href="https://www.tnonetwork.com/show/pedroconlasmascotas"
            variant="outlined"
            color="primary"
            size="large"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ height: 54 }}
            fullWidth
          >
            Ver Pedro con las Mascotas
          </Button>
        </Box>
      </Box>
      <Box marginTop={4} textAlign="center">
        <Typography variant="body2" color="textSecondary">
          © TNO Network 2026 | The Content Evolution.
        </Typography>
      </Box>
    </Box>
  );
};

export default AreYouReady;
